<template>
  <div class="stock-record-bd tb" v-if="funcView.stock_record_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 导出 -->
        <el-form-item v-if="funcView.stock_record_export" style="float: right" :class="{ 'mr-0': funcView.stock_record_export }">
          <el-button class="table-set" style="vertical-align: top" @click="exportTable('DeviceStockRecordExport', formSearch)">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <el-form-item style="float: right" :class="{ 'mr-0': !funcView.stock_record_export }">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_stock_record.jshModemSNcrkdh')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
        <el-form-item v-if="isHq">
          <el-radio-group v-model="formSearch.type" @change="onPageChange({ page: 1 })">
            <el-radio-button label="">{{ $t('Common.com_all') }}</el-radio-button>
            <el-radio-button :label="1">{{ $t('dms_stock_record.zong_bu') }}</el-radio-button>
            <el-radio-button :label="2">{{ $t('dms_stock_record.fu_wu_gong_si') }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('dms_stock_record.chan_pin_xing_hao')">
          <custom-select url="productCodeSelectList" v-model="formSearch.productCode" :props="{ label: 'productCode', value: 'productCode' }" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_stock_record.chu_ku_gong_si')">
          <el-input v-model="formSearch.outOrgName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_stock_record.ru_ku_gong_si')">
          <el-input v-model="formSearch.inOrgName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_stock_record.chu_ku_shi_jian')">
          <custom-date-picker
            style="width: 100%"
            @change="onPageChange({ page: 1 })"
            v-model="timerOut"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('dms_stock_record.ru_ku_shi_jian')">
          <custom-date-picker
            style="width: 100%"
            @change="onPageChange({ page: 1 })"
            v-model="timerIn"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
          ></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table ref="table" index height="100%" tableCode="stock_record" :data="tableList" @filter="filterChange" @sort="sortChange" @column="setColumn"></custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  name: 'stockRecord',
  components: {},
  data() {
    return {
      formSearch: {
        type: '',
        productCode: '',
        outStartTime: '',
        outEndTime: '',
        inStartTime: '',
        inEndTime: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,

        outOrgName: '',
        inOrgName: '',
      },

      timerOut: [],
      timerIn: [],
      tableList: [],
      totalRows: null,

      dialogVisible: false,
      dialogModel: {},
      dialogData: {},
      link: null,
    };
  },
  activated: function () {
    this.getTableList();
  },
  computed: {
    // 是否总部
    isHq() {
      const userInfo = this.$store.state.userInfo || {};
      return userInfo.bizType === 'HQ';
    },
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);

    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
    if (this.isHq) {
      this.formSearch.type = 1;
    }
  },
  methods: {
    // 获取表格数据列表
    getTableList: function () {
      this.formSearch.outStartTime = this.timerOut ? this.timerOut[0] : '';
      this.formSearch.outEndTime = this.timerOut ? this.timerOut[1] : '';
      this.formSearch.inStartTime = this.timerIn ? this.timerIn[0] : '';
      this.formSearch.inEndTime = this.timerIn ? this.timerIn[1] : '';
      this.$getJSON(apis.DeviceStockRecord, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 清除
    clearFilter: function () {
      this.timerOut = [];
      this.timerIn = [];
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.getTableList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'style/colors.scss';
</style>
